// 基本证据字段
let evidenceBaseFields = [
  'localFile',
  'evidenceType',
]
// 需要照片类型证据时显示的字段
let photoEvidenceFields = [
  'evidenceQuality',
  'clarity',
  'imageRecognitionType',
  'takePhotoAuxiliaryLine',
  'panoramicCamera',
  'allowReusePhoto',
]
// 需要视频类型证据时显示的字段
let videoEvidenceFields = [
  'evidenceQuality',
  'minDuration',
]
// 需要录音类型证据时显示的字段
let recordEvidenceFields = [
  'evidenceQuality',
  'minDuration',
  'allowCrossSubjectRecord',
]

let qrcodeEvidenceFields = [
  'reportedTablesAssociationStepId'
]

// 所有证据相关字段
let evidenceFields = _.uniq([].concat(evidenceBaseFields, photoEvidenceFields, videoEvidenceFields, recordEvidenceFields, qrcodeEvidenceFields))

export default {
  evidence: evidenceFields,
  types: {
    photo: [...evidenceBaseFields, ...photoEvidenceFields],
    qrcode: [...evidenceBaseFields, ...qrcodeEvidenceFields],
    video: [...evidenceBaseFields, ...videoEvidenceFields],
    record: [...evidenceBaseFields, ...recordEvidenceFields],
  },
  selectTypes: {
    photo: [
      'evidenceType',
      'evidenceQuality',
      'clarity',
      'imageRecognitionType',
      'allowReusePhoto'
    ],
    qrcode: [
      'evidenceType',
      ...qrcodeEvidenceFields,
    ],
    video: ['evidenceType', ...videoEvidenceFields],
    record: ['evidenceType', ...recordEvidenceFields],
  }
}



// WEBPACK FOOTER //
// ./src/views/question-editor/format/convert-fields/evidence-types.js